import { legacyTheme, styled } from '@prose-ui/legacy';

import { BasicModal } from 'Components/BasicModal';
import { Button } from 'Components/LegacyButton';
import { Typography } from 'Components/Typography';

const StyledModal = styled(BasicModal)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${legacyTheme.spacing.s24};
  /* @Eric: revert some basic modal rules to have a smaller modal */
  height: revert;
  /* @Eric: revert some basic modal rules to have a smaller modal */
  padding: ${legacyTheme.spacing.s32};

  border-radius: ${legacyTheme.spacing.s8};
`;

type MedicalModalProps = {
  isOpen?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const MedicalModal = ({ isOpen = false, onClose, onConfirm }: MedicalModalProps) => (
  <StyledModal hideClose isOpen={isOpen} onClose={onClose}>
    <Typography variant="p1">
      Please note that while our custom skincare is formulated to work with your skin’s unique
      needs, we do not treat any medical skin conditions you may have. As always, we recommend
      checking with your doctor if you have any concerns before trying new products.
    </Typography>
    <Button fullWidth onClick={onConfirm} variant="vertFull">
      I understand
    </Button>
  </StyledModal>
);
